import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    status: "signIn",
  },
  reducers: {
    changeLoginStatus: (state, action) => {
      state.status = action.payload; // Update `status` instead of `isOpen`
    },
  },
});

export const { changeLoginStatus } = loginSlice.actions;

export const selectLoginStatus = (state) => state.login.status;

export default loginSlice.reducer;
